import {FormSubmissionData} from "../forms/interfaces/form-submission-data";
import {PageField} from "../forms/interfaces/page-field";
import { FormCombineItem } from "../interfaces/form-combine-item.interface";

export function getSubmittedFieldLabel(field: PageField | FormCombineItem, submissionData: FormSubmissionData[]): string | undefined {
  const matchingData = submissionData.find((datum) => datum.fieldId === field.id);

  return matchingData?.fieldLabel || field.label;
}
